// 中文（繁體）翻譯
export default {
  // 導航
  navHome: '首頁',
  navMethod: 'TSMC 方法論',
  navServices: '服務項目',
  navAbout: '關於我們',
  navFaq: '常見問題',
  navContact: '聯絡預約',
  navBlog: 'BLOG',
  
  // 按鈕
  bookNow: '立即預約',
  lineConsult: 'LINE 諮詢',
  bookNowFull: '立即預約 Book Now',
  
  // 首頁 Hero
  heroTitle1: '以工程師的精準',
  heroTitle2: '找回身體的結構力學',
  heroSubtitle: '台南佳里專業美式整復 · 運動按摩',
  heroDesc: '結合美國、日本、澳洲、加拿大頂尖技術 | 深層筋膜放鬆 | 結構力學調整',
  heroCert: '多國認證技術',
  heroPrice: '收費透明公開',
  heroTime: '週六至週三營業',
  
  // 什麼是美式整復
  whatIsTitle: '什麼是',
  whatIsChiro: '美式整復',
  whatIsSubtitle: "Chiropractic 起源、制度與流派理論",
  whatIsPara1: "起源於 1895 年，",
  whatIsChiroFull: "Chiropractic",
  whatIsPara1b: "是源自美國的徒手專業流派，由",
  whatIsFounder: 'D. D. Palmer',
  whatIsPara1c: "發展並推廣。不同於一般按摩，部分流派更重視結構系統、關節活動與整體身體力學之間的關聯。",
  whatIsRegulation: "世界衛生組織（WHO）曾發布 Chiropractic 基礎培訓與安全準則；各國則依自己的法規建立不同的教育、資格與執業制度。",
  whatIsPara2: "在部分 Chiropractic 流派的理論中，脊椎或關節的「錯位／功能障礙」被用來描述關節活動與身體使用方式；該流派主張透過特定手法進行調整，",
  whatIsRestore: "以恢復正常活動度，並以減緩不適、改善姿勢與穩定神經系統功能為理論目標",
  whatIsPara2b: "。上述內容屬於該流派的歷史與理論敘事。",
  whatIsDisclaimer: "這不代表台筋殿提供疾病診斷、治療或特定效果保證，也不取代合格醫療專業人員的檢查與處置。",
  whatIsBoxTitle: "追求「從整體理解身體使用方式」",
  whatIsBoxDesc: "該流派以日常受力、動作習慣與不同部位的相互配合作為理解架構：",
  whatIsCycle1: "承受重複力量 → 肌肉容易疲勞與緊繃",
  whatIsCycle2: "長時間固定姿勢 → 身體使用方式逐漸偏向",
  whatIsCycle3: "不同部位互相配合 → 形成代償與受力改變",
  whatIsCycle4: "長期循環影響 → 緊繃感、活動習慣與身體感受彼此牽動",
  chiroCardTitle: '美式整復',
  chiroCardDesc: "重視",
  chiroCardFocus: "特定手法與關節活動",
  chiroCardDesc2: "，並依個人舒適度安排調理流程",
  massageCardTitle: '運動按摩',
  massageCardDesc: '專精於',
  massageCardFocus: '肌肉的放鬆',
  massageCardDesc2: "，作為日常放鬆與運動後保養",
  whatIsSummary: '台筋殿融合兩者',
  whatIsSummary2: "，依不同生活型態、日常需求與主觀感受安排非醫療性的手法與放鬆流程",
  
  // TSMC 方法論
  methodTitle: 'TSMC',
  methodTitleSuffix: '方法論',
  methodSubtitle: '台筋殿獨特的身體結構調整系統',
  methodT: 'Technology',
  methodTSub: '多國技術融合',
  methodTDesc: '整合美國、日本、澳洲、加拿大頂尖整復技術，提供最全面的調理方案',
  methodS: 'Stretching',
  methodSSub: '伸展與結構調整',
  methodSDesc: '從脊椎、骨盆到四肢關節，系統性改善身體結構失衡',
  methodM: 'Mobility',
  methodMSub: '活動度優化',
  methodMDesc: '針對深層肌肉與筋膜，提升關節活動範圍與靈活度',
  methodC: 'Chiro',
  methodCSub: '客製化整復',
  methodCDesc: '根據個人體質、不適感、生活習慣，設計專屬調理方案',
  methodSystemTitle: '身體是精密的生物機械系統',
  methodSystem1: '骨骼連接肌肉，肌肉拉著骨骼',
  methodSystem2: '肌肉出力，撐起骨骼，骨骼撐起整個身體',
  methodSystem3: '對抗地心引力及應對生活中的各種力量',
  
  // 服務項目
  services: '專業服務項目',
  servicesDesc: '雙軌整復方案 - 美式整復 + 運動按摩',
  chiro: '美式整復',
  chiroService: "特定手法 · 日常活動保養 · 身體使用覺察",
  chiroFeature1: "依個人舒適度安排特定手法",
  chiroFeature2: "了解日常動作與身體使用習慣",
  chiroFeature3: "適合久坐、久站與體力工作族群安排日常保養",
  chiroPrice: '$1000',
  chiroPriceSuffix: '起 / 30-40 分鐘',
  massage: '美式整復加運動按摩',
  massageService: "特定手法 · 深層筋膜放鬆 · 運動後保養",
  massageFeature1: "依個人需求安排深層肌肉與筋膜放鬆",
  massageFeature2: "規律運動族群的運動後日常放鬆",
  massageFeature3: "久坐與體力工作族群的全身放鬆",
  massagePrice: '$2300',
  massagePriceSuffix: '/ 90 分鐘',
  suitable: '適合：',
  chiroSuitable: "久坐辦公族、久站工作族、體力工作族、重視日常身體保養者",
  massageSuitable: "規律運動族、久坐上班族、體力工作族、運動後希望放鬆者",
  
  // 服務總結
  servicesSummary1: "整復 + 按摩雙軌服務",
  servicesSummary2: "，依生活型態與放鬆需求安排個人化的日常身體調理",
  
  // 誰需要我們的服務
  whoNeedsTitle: "哪些生活型態適合安排日常身體調理？",
  whoNeedsSubtitle: "以下依日常活動、工作型態與身體使用情境分類，作為安排非醫療性放鬆與身體保養的參考。",
  
  // 適合對象
  targetOffice: "久坐辦公族",
  targetOfficeSymptom1: "長時間使用電腦或手機",
  targetOfficeSymptom2: "經常開會、伏案或維持坐姿",
  targetOfficeSymptom3: "平日日常活動量較少",
  targetOfficeSymptom4: "希望定期安排全身放鬆",
  
  targetAthlete: "規律運動族",
  targetAthleteSymptom1: "有固定訓練或運動習慣",
  targetAthleteSymptom2: "運動後希望安排肌肉放鬆",
  targetAthleteSymptom3: "經常進行重複性的運動動作",
  targetAthleteSymptom4: "重視伸展、休息與日常保養",
  
  targetPosture: "久站走動族",
  targetPostureSymptom1: "工作時需要長時間站立",
  targetPostureSymptom2: "經常走動或維持固定姿勢",
  targetPostureSymptom3: "下肢日常使用時間較長",
  targetPostureSymptom4: "下班後希望安排身體放鬆",
  
  targetChronic: "體力工作族",
  targetChronicSymptom1: "工作中經常搬運或出力",
  targetChronicSymptom2: "需要反覆彎腰、蹲起或伸手",
  targetChronicSymptom3: "長時間重複相同動作",
  targetChronicSymptom4: "希望依工作型態安排日常保養",
  
  targetSenior: "通勤駕駛族",
  targetSeniorSymptom1: "每天長時間開車或騎車",
  targetSeniorSymptom2: "經常長途通勤或移動",
  targetSeniorSymptom3: "工作中需要維持固定駕駛姿勢",
  targetSeniorSymptom4: "希望在休息時間安排全身放鬆",
  
  targetPregnant: "重視日常保養者",
  targetPregnantSymptom1: "想定期留時間照顧自己",
  targetPregnantSymptom2: "偏好依舒適度調整手法與力道",
  targetPregnantSymptom3: "重視身體使用習慣與日常覺察",
  targetPregnantSymptom4: "希望建立適合自己的放鬆節奏",
  
  // 關於我們
  aboutTitle: '從工程師到整復師的理念',
  aboutSubtitle: 'From Engineer to Bodyworker',
  aboutPara1: '工程師的思維方式，是追求',
  aboutPara1Highlight: '「從根本解決問題」',
  aboutPara1b: '。如同 Debug 程式碼一般，我們不只處理疼痛表象，更要找出結構失衡的根源。',
  aboutPara2: '每一次調整，都像是重新編譯身體的結構程式碼。我們結合',
  aboutPara2Highlight: '美國、日本、澳洲、加拿大',
  aboutPara2b: '的頂尖手法，用工程師的精準度，為您的身體進行最深層的優化。',
  aboutPara3: '在台南佳里，我們提供的不只是傳統推拿按摩，而是結合現代解剖學、生物力學、運動科學的',
  aboutPara3Highlight: '系統性身體調理',
  aboutPara3b: '。',
  aboutQuote: '身體是一套精密的生物機械系統，需要的不是暫時性的修補，而是系統性的結構重建。我們用工程師的邏輯思維，搭配專業整復手法，為每位客戶找回身體的最佳狀態。',
  aboutQuoteAuthor: '— 台筋殿創辦人',
  
  // 常見問題
  faqTitle: '常見問題',
  faqSubtitle: '關於台南佳里整復推拿的疑問',
  
  // FAQ 問答
  faq1Q: '美式整復和傳統推拿有什麼不同？',
  faq1A: '美式整復著重於「骨骼關節排列」，透過精準手法使關節恢復正常活動度，從根本改善身體力學。傳統推拿則側重於經絡疏通與肌肉放鬆。台筋殿結合兩者優點，提供最全面的調理。',
  
  faq2Q: '會不舒服嗎？安全嗎？',
  faq2A: '我們的手法經過專業訓練，過程中可能會有輕微的拉伸感或壓力感，但不會造成疼痛。所有操作都在安全範圍內進行，並會根據您的狀況調整力道。',
  
  faq3Q: '多久需要調理一次？',
  faq3A: '依個人狀況而定。急性期建議每週1-2次，慢性問題初期可能需要較密集的調理（每週1次），待改善後可延長至2-4週保養一次。我們會依您的狀況給予專業建議。',
  
  faq4Q: '第一次來需要帶什麼？',
  faq4A: '建議穿著寬鬆舒適的衣物，如果曾經有做過身體檢查（X光、MRI等），可以一併帶來參考。我們會先進行詳細的身體評估，再制定專屬的調理計畫。',
  
  faq5Q: '你們的收費如何計算？',
  faq5A: '美式整復 $1000 起（30-40分鐘），美式整復運動按摩 $2300（90分鐘）。收費公開透明，無隱藏費用。首次體驗建議從美式整復開始，讓我們評估您的狀況後，再建議適合的課程。',
  
  faq6Q: '台南佳里以外的地區可以來嗎？',
  faq6A: '當然可以！我們服務台南各區的客人，包含佳里、麻豆、學甲、將軍、七股、西港、安定等地。交通便利，並提供 Google Maps 導航。',
  
  // 客戶評論
  reviewsTitle: '客戶真實回饋',
  reviewsSubtitle: '來自客戶的五星好評',
  reviewsDisclaimer: '台筋殿並非醫療機構；以下節錄自 Google 顧客評論，僅代表評論者個人感受，不代表本店對醫療或服務效果的宣稱與保證。',
  reviewsViewAll: '查看所有 Google 評論',
  reviewsFrom: '來源',
  
  // 國際進修
  trainingTitle: '國際進修・技術精進',
  trainingSubtitle: 'International Training',
  trainingIntro: '多年來持續向世界各地的專業講師學習，不斷提升技術水平，將國際先進的整復理念帶回台灣。',
  trainingYear: '年',
  trainingStats1: '持續進修',
  trainingStats1Val: '10+ 年',
  trainingStats2: '國際講師',
  trainingStats2Val: '10+ 位',
  trainingStats3: '跨國學習',
  trainingStats3Val: '多次',
  
  // CTA
  ctaTitle: "準備安排日常身體保養？",
  ctaDesc: "依您的生活型態與放鬆需求，預約適合的非醫療性身體調理服務",
  ctaBooking: '線上預約',
  ctaLine: 'LINE 線上諮詢',
  ctaTransparent: '收費透明',
  ctaTransparentDesc: '無隱藏費用\n明碼實價',
  ctaCert: '專業認證',
  ctaCertDesc: '多國技術整合\n持續進修',
  ctaFlex: '彈性預約',
  ctaFlexDesc: '線上預約系統\n方便快速',
  
  // Footer
  footerHours: '營業時間',
  footerHoursDays: '週六至週三',
  footerHoursTime: '11:00 - 21:40',
  footerHoursClosed: '週四、週五公休',
  footerLocation: '地點位置',
  footerLocationCity: '台南市佳里區',
  footerLocationAddr: '文新里安西130號之95號',
  footerLocationMap: 'Google 地圖導航',
  footerLocationSearch: '直接開啟台筋殿 Google 地圖定位',
  footerLocationGuide: '不用自行搜尋地址，點下方按鈕即可直接導航到台筋殿位置。',
  footerLocationOpenMap: '直接開啟 Google 地圖導航',
  footerContact: '聯絡方式',
  footerContactLine: 'LINE 官方帳號',
  footerFollow: '追蹤我們',
  footerServices: '服務項目',
  footerService1: '美式整復 Chiropractic',
  footerService2: "日常活動保養",
  footerService3: '運動按摩 Sports Massage',
  footerService4: '深層筋膜放鬆',
  footerService5: "運動後身體保養",
  footerService6: "生活型態與動作習慣了解",
  footerDisclaimer: '重要聲明：',
  footerDisclaimerText: "台筋殿提供傳統整復推拿與運動按摩等非醫療性身體調理服務，以日常放鬆、身體保養與提升身體覺察為目的，不提供疾病診斷、治療或復健服務。若有持續疼痛、麻木無力、暈眩、急性外傷或其他疑似病理狀況，請先尋求合格醫師評估。",
  footerBookingBtn: '🎯 立即線上預約',
  footerCopyright: '© 2026 台筋殿 TSMC - 台南佳里專業美式整復推拿工作室',
  footerTagline1: 'Technology of Stretching & Mobility Chiro',
  footerTagline2: 'Tainan Jiali · Professional Chiropractic & Sports Massage',

  
  // Service Flow
  serviceFlowTitle: '我們的服務流程',
  serviceFlowSubtitle: '從專業評估到精準調理，每個步驟都為您的健康把關',
  serviceFlowPhase1: '評估階段',
  serviceFlowPhase2: '調理階段',
  serviceFlowScrollHint: '滑動查看完整流程',
  step1Title: '人體特殊評估',
  step1Desc: '依個人身體狀況安排特定動作觀察，了解日常活動與身體使用情形',
  step2Title: '長短腳評估',
  step2Desc: '精準測量骨盆與下肢長度差異，找出結構失衡點',
  step3Title: '足部檢查',
  step3Desc: '檢查足底壓力分布與足弓狀態，評估步態問題',
  step4Title: '壓力測試',
  step4Desc: '評估肌肉張力與關節活動度，確認問題區域',
  step5Title: '背部調理',
  step5Desc: '深層肌筋膜放鬆，改善背部肌群張力不平衡',
  step6Title: '肩頸調理',
  step6Desc: '針對肩頸僵硬進行精準調整，恢復活動度',
  step7Title: '完整檢查',
  step7Desc: '調理後再次評估，確認改善效果與後續建議'
};
